/**
 * Client-side structured logger.
 * Dev + Production safe: logs only on meaningful events, no spam.
 * Respects config.features.debugMode for detailed output.
 */

import config from '../config';

const isDev = typeof import.meta !== 'undefined' && import.meta.env?.DEV === true;
const shouldLog = (): boolean => isDev || config.features.debugMode === true;

export function logOutputsPushEvent(
  event: string,
  data: Record<string, unknown>
): void {
  if (!shouldLog()) return;
  try {
    const payload = { event, ...data, timestamp: Date.now() };
    const msg = `[OutputsPush] ${event}`;
    // Structured for devtools; avoid console.log in production unless debugMode
    if (config.features.debugMode) {
      (console as Record<string, (m: string, d: unknown) => void>).info?.(msg, payload);
    } else if (isDev) {
      (console as Record<string, (m: string, d: unknown) => void>).info?.(msg, payload);
    }
  } catch {
    // No-op on logger failure
  }
}
